export default __webpack_public_path__ + "static/media/acceso-nueva-venta.a200cd98.svg";